module.exports = __webpack_public_path__ + "fonts/Inter-700-latin70.260c81a.woff2";